import React from "react";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css"; // Choose your PrimeReact theme
import "primereact/resources/primereact.min.css";
import Logo from "../assets/logo/logo.png";
import { Link } from "react-router-dom";
import { Menubar } from "primereact/menubar";

function Header() {
  const menuItems = [
    { label: "Home", command: () => (window.location.href = "/") },
    { label: "About", command: () => (window.location.href = "/about") },
    {
      label: "Service",
      items: [
        { label: "TaxiDo", command: () => (window.location.href = "/taxido") },
        { label: "HandyMan", command: () => (window.location.href = "/handyman") },
      ],
    },
    {
      label: "Pages",
      items: [
        { label: "FAQs", command: () => (window.location.href = "/faq") },
        { label: "Terms Of Service", command: () => (window.location.href = "/terms") },
        { label: "Privacy Policy", command: () => (window.location.href = "/privacy") },
      ],
    },
    { label: "Blog", command: () => (window.location.href = "/blog") },
    { label: "Contact", command: () => (window.location.href = "/contact") },
  ];

  const start = (
    <Link className="navbar-brand" to="/">
      <img src={Logo} alt="logo" style={{ width: "150px" }} />
    </Link>
  );

  const end = (
    <div className="nav-right">
      <div className="nav-right-btn mt-2">
        <Link to="/taxido" className="theme-btn">
          <span className="fas fa-taxi"></span> Get A TaxiDo
        </Link>
      </div>
    </div>
  );

  return (
    <div>
      <header className="header w-100">
        <div className="header-top">
          <div className="container">
            <div className="header-top-wrapper">
              <div className="header-top-left">
                <div className="header-top-contact">
                  <ul>
                    <li></li>
                    <li>
                      <Link to="tel:+265992592759">
                        <i className="pi pi-whatsapp"></i> +265 992 592 759
                      </Link>
                    </li>
                    <li>
                      <Link to="mailto:info@serviswiftmw.com">
                        <i className="pi pi-envelope"></i> info@serviswiftmw.com
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <Link to="https://facebook.com">
                    <i className="pi pi-facebook"></i>
                  </Link>
                  <Link to="https://x.com">
                    <i className="pi pi-twitter"></i>
                  </Link>
                  <Link to="https://linkedin.com">
                    <i className="pi pi-linkedin"></i>
                  </Link>
                  <Link to="https://instagram.com">
                    <i className="pi pi-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Menubar id="main_nav" className="pull-right" style={{width:"100%",background:"white",border:"none"}} model={menuItems} start={start} end={end} />
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Header;